enum ColourSwatchVariantEnum {
  Default = 'default',
  Detailed = 'detailed',
  Large = 'large',
  Simple = 'simple',
}

export default ColourSwatchVariantEnum;
